var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-navbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isGame),
      expression: "!isGame"
    }],
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": _vm.variant
    }
  }, [_c('div', {
    staticClass: "header-l mr-auto nav-menu text-left"
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('b-nav-form', {
    staticStyle: {
      "display": "block !important"
    }
  }, [_c('span', {
    staticClass: "btn-group nav-buttons"
  }, [(!_vm.whiteLabel) ? _c('b-button', {
    staticClass: "btn-icon",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/menu')
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-list",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.whiteLabel) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-intro",
      modifiers: {
        "modal-intro": true
      }
    }],
    staticClass: "btn-icon",
    attrs: {
      "variant": _vm.variantNavButton
    }
  }, [_c('svg', {
    staticClass: "bi bi-question-circle",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/' || _vm.$route.path === '/tang' || _vm.$route.path === '/dob' || _vm.$route.path === '/preme' || _vm.$route.path === '/zora') ? _c('b-button', {
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.doUpload()
      }
    }
  }, [_vm._v("\n                UPLOAD \n                ")]) : _vm._e(), _vm._v(" "), (!_vm.canBuy && _vm.$route.path === '/' && _vm.connectAccountEnsAvatar != '') ? _c('b-button', {
    staticClass: "btn-icon",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": _vm.doUploadAvatar
    }
  }, [_c('img', {
    staticClass: "ensAvatar",
    attrs: {
      "src": _vm.connectAccountEnsAvatar
    }
  })]) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mr-0 p-0 header-m"
  }, [(!_vm.whiteLabel) ? _c('span', {
    staticClass: "honk-text mbh-title",
    on: {
      "click": function($event) {
        return _vm.navigateTo('/')
      }
    }
  }, [_vm._v("Million Bit Homepage")]) : _vm._e(), _vm._v(" "), (!_vm.canBuy) ? _c('p', {
    staticClass: "subtitle dm-sans-text"
  }, [_vm._v("\n        1,000,000 pixels \n        • "), (_vm.ethTokenToggle) ? _c('span', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.ethPerPixel)
    }
  }), _vm._v(" "), _c('span', [_vm._v("ETH")])]) : _vm._e(), _vm._v(" "), (!_vm.ethTokenToggle) ? _c('span', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.tokenPerPixel)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  })]) : _vm._e(), _vm._v("\n         per pixel \n        • Own a bit of onchain history!\n      ")]) : _vm._e(), _vm._v(" "), (_vm.canBuy) ? _c('div', {
    staticClass: "d-block text-center mb-3"
  }, [_c('b-nav-form', {
    staticClass: "text-center"
  }, [(_vm.canToggleEthToken) ? _c('span', {
    staticClass: "btn-group"
  }, [_c('b-button', {
    class: {
      'btn-outline-lighter': !_vm.ethTokenToggle
    },
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.doToggleEthToken(true)
      }
    }
  }, [_c('span', [_vm._v("ETH")])]), _vm._v(" "), _c('b-button', {
    class: {
      'btn-outline-lighter': _vm.ethTokenToggle
    },
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.doToggleEthToken(false)
      }
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [(_vm.ethTokenToggle) ? _c('span', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.ethAmtFormatted)
    }
  }), _vm._v(" ETH")]) : _vm._e(), _vm._v(" "), (!_vm.ethTokenToggle) ? _c('span', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.tokenAmt)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('b-form-input', {
    ref: "formInputValueUrl",
    staticClass: "mr-md-2",
    attrs: {
      "size": "md",
      "placeholder": "http link address",
      "type": "url",
      "id": "link-url",
      "value": _vm.formInputUrl
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.blurInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.canSend) ? _c('b-button', {
    attrs: {
      "variant": "warning",
      "disabled": _vm.buyLoading
    },
    on: {
      "click": _vm.doBuy
    }
  }, [_c('span', [(_vm.buyLoading) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _vm._v(" "), (_vm.canMint) ? _c('span', [_vm._v("MINT")]) : _c('span', [_vm._v("SEND")])])]) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-r ml-auto connect-menu text-right"
  }, [(!_vm.connectAccountAddress) ? _c('b-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "connect-wallet",
      "variant": 'connect'
    },
    on: {
      "click": function($event) {
        return _vm.connectWallet()
      }
    }
  }, [_vm._v("\n        Connect Wallet\n      ")]) : _vm._e(), _vm._v(" "), (_vm.connectAccountAddress) ? _c('span', {
    staticClass: "btn-group"
  }, [_c('b-button', {
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/plots')
      }
    }
  }, [(_vm.connectAccountEnsAvatar) ? _c('span', [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.connectAccountEnsAvatar
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.connectAccountEnsName) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.connectAccountEnsNameTrunc)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.connectAccountEnsName) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.connectAccountAddressTrunc)
    }
  }) : _vm._e()]), _vm._v(" "), _c('b-button', {
    staticClass: "disconnect",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.doDisconnect()
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-box-arrow-right",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.connectAccountAddress && !_vm.isBaseChain(_vm.connectAccountChainId)) ? _c('div', {
    staticClass: "my-2"
  }, [_c('b-button', {
    attrs: {
      "variant": 'warning'
    },
    on: {
      "click": function($event) {
        return _vm.switchToBaseChain()
      }
    }
  }, [_vm._v("Switch to Base")])], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.rewardsMsg) ? _c('div', {
    staticClass: "rewards-header"
  }, [_vm._v("\n    " + _vm._s(_vm.rewardsMsg) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.showPromo) ? _c('div', {
    staticClass: "promo-header"
  }, [_vm._v("\n    " + _vm._s(_vm.promoMsg) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('router-view', {
    ref: "routerViewRef"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isGame && !_vm.isZora),
      expression: "!isGame && !isZora"
    }],
    staticClass: "mb-5",
    attrs: {
      "id": "countdown"
    }
  }, [(!_vm.whiteLabel) ? _c('p', {
    staticClass: "text-bold"
  }, [_vm._v("Pixel price goes up with each minted plot!")]) : _vm._e(), _vm._v(" "), (_vm.whiteLabel) ? _c('p', {
    staticClass: "text-bold"
  }, [_vm._v("Powered by the "), _c('a', {
    attrs: {
      "href": "https://millionbithomepage.com",
      "target": "_blank"
    }
  }, [_vm._v("Million Bit Homepage")])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-connect",
      "title": "Connect your wallet",
      "hide-footer": "",
      "size": "sm"
    }
  }, [(!_vm.connectAccountAddress) ? _c('b-button', {
    staticClass: "btn btn-block btn-primary mb-4",
    attrs: {
      "id": "create-wallet",
      "variant": 'connect'
    },
    on: {
      "click": function($event) {
        return _vm.createWallet()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4IDU2YzE1LjQ2NCAwIDI4LTEyLjUzNiAyOC0yOFM0My40NjQgMCAyOCAwIDAgMTIuNTM2IDAgMjhzMTIuNTM2IDI4IDI4IDI4WiIgZmlsbD0iIzFCNTNFNCIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAyOGMwIDExLjU5OCA5LjQwMiAyMSAyMSAyMXMyMS05LjQwMiAyMS0yMVMzOS41OTggNyAyOCA3IDcgMTYuNDAyIDcgMjhabTE3LjIzNC02Ljc2NmEzIDMgMCAwIDAtMyAzdjcuNTMzYTMgMyAwIDAgMCAzIDNoNy41MzNhMyAzIDAgMCAwIDMtM3YtNy41MzNhMyAzIDAgMCAwLTMtM2gtNy41MzNaIiBmaWxsPSIjZmZmIi8+PC9zdmc+"
    }
  }), _vm._v("\n       Create Wallet\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.connectAccountAddress && _vm.providers.length === 0) ? _c('a', {
    staticClass: "btn btn-block btn-primary mb-4",
    attrs: {
      "href": _vm.deepLinkMetamask,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,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"
    }
  }), _vm._v(" Metamask")]) : _vm._e(), _vm._v(" "), (!_vm.connectAccountAddress && _vm.providers.length === 0) ? _c('a', {
    staticClass: "btn btn-block btn-primary mb-4",
    attrs: {
      "href": _vm.deepLinkCoinbase,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4IDU2YzE1LjQ2NCAwIDI4LTEyLjUzNiAyOC0yOFM0My40NjQgMCAyOCAwIDAgMTIuNTM2IDAgMjhzMTIuNTM2IDI4IDI4IDI4WiIgZmlsbD0iIzFCNTNFNCIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAyOGMwIDExLjU5OCA5LjQwMiAyMSAyMSAyMXMyMS05LjQwMiAyMS0yMVMzOS41OTggNyAyOCA3IDcgMTYuNDAyIDcgMjhabTE3LjIzNC02Ljc2NmEzIDMgMCAwIDAtMyAzdjcuNTMzYTMgMyAwIDAgMCAzIDNoNy41MzNhMyAzIDAgMCAwIDMtM3YtNy41MzNhMyAzIDAgMCAwLTMtM2gtNy41MzNaIiBmaWxsPSIjZmZmIi8+PC9zdmc+"
    }
  }), _vm._v(" Coinbase")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.providers), function(provider) {
    return _c('span', [(!_vm.connectAccountAddress) ? _c('b-button', {
      staticClass: "btn-block btn-primary mb-4",
      attrs: {
        "variant": 'connect',
        "disabled": _vm.isConnecting
      },
      on: {
        "click": function($event) {
          return _vm.doConnect(provider)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": provider.info.icon
      }
    }), _vm._v(" " + _vm._s(provider.info.name) + "\n      ")]) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-token",
      "title": "Own a bit of blockchain history!",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('h2', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('a', {
    staticClass: "btn btn-block btn-outline-dark btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    attrs: {
      "stroke": "currentColor",
      "fill": "none",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "height": "1em",
      "width": "1em",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "width": "14",
      "height": "14",
      "x": "8",
      "y": "8",
      "rx": "2",
      "ry": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
    }
  })]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.contractAddress)
    },
    on: {
      "click": function($event) {
        return _vm.doCopyToClipboard(_vm.contractAddress)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-dark btn-block",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.watchToken()
      }
    }
  }, [_vm._v("Watch token in wallet")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("Launch status")]), _vm._v(" "), _c('p', [_vm._v("Coming soon.. join us on telegram for updates on the upcoming launch!")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-alert",
      "hide-header": "",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('h3', {
    staticClass: "text-center",
    domProps: {
      "textContent": _vm._s(_vm.alertMsg)
    }
  }), _vm._v(" "), (_vm.alertSwapOpts && _vm.alertSwapOpts.amountNeeded) ? _c('div', [_c('h5', {
    staticClass: "text-center m-2"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.alertSwapOpts.amountNeededFormatted)
    }
  }), _vm._v(" more "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  }), _vm._v(" needed to mint your plot.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-block"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.doSwap(_vm.alertSwapOpts.amountNeeded)
      }
    }
  }, [_vm._v("\n          SWAP\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "external-link m-0 btn btn-block btn-primary btn-lg",
    staticStyle: {
      "max-width": "100px"
    },
    attrs: {
      "href": "https://app.uniswap.org/swap?outputCurrency=0x5ca35371263CA25e0BC8005fB44e0c37D0a0BdfD&chain=base",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "20px"
    },
    attrs: {
      "src": "/static/external-link.svg",
      "alt": "Swap on Uniswap"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-swap",
      "hide-header": "",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('h1', [_vm._v("Swap")]), _vm._v(" "), _c('h3', {
    staticClass: "text-center",
    domProps: {
      "textContent": _vm._s(_vm.alertMsg)
    }
  }), _vm._v(" "), (_vm.alertSwapOpts && _vm.alertSwapOpts.amountNeeded) ? _c('div', [_c('h5', {
    staticClass: "text-center m-2"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.alertSwapOpts.amountNeededFormatted)
    }
  }), _vm._v(" more "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  }), _vm._v(" needed to mint your plot.")]), _vm._v(" "), _c('br'), _vm._v("\n      eth\n      million zora post\n      "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.doSwap(_vm.alertSwapOpts.amountNeeded)
      }
    }
  }, [_vm._v("\n          SWAP\n        ")])])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-intro",
      "title": "👋 Welcome to the Million Bit Homepage!",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('p', [_vm._v("\n      Add your image to the homepage and be forever immortalized on the blockchain!\n    ")]), _vm._v(" "), _c('h3', {
    staticClass: "my-4"
  }, [_vm._v("💰 What you get")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v("NFT of your plot!")]), _vm._v("\n      You own your plot forever. List it on \n      "), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://magiceden.us/collections/base/0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e",
      "target": "_blank"
    }
  }, [_vm._v("Magic Eden")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/plots')
      }
    }
  }, [_vm._v("update your plot")]), _vm._v(".\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v("Earn rewards for your NFTs.")]), _vm._v("\n      Get rewarded for the pixels you've minted.\n      "), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/plots')
      }
    }
  }, [_vm._v("Claim now")]), _vm._v(".\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v("Join the MBH community.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/spaces')
      }
    }
  }, [_vm._v("Twitter X spaces")]), _vm._v(" and access to our exclusive Twitter X group.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v("Included in marketing and games.")]), _vm._v("\n      Instantly included in our games "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/break')
      }
    }
  }, [_vm._v("Break")]), _vm._v(" & "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/drop')
      }
    }
  }, [_vm._v("Drop")]), _vm._v(".\n      ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "my-4"
  }, [_vm._v("👩‍🏫 How it works")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', {
    staticClass: "pr-2"
  }, [_vm._v("Step 1")]), _vm._v(" \n      Click on the UPLOAD button.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', {
    staticClass: "pr-2"
  }, [_vm._v("Step 2")]), _vm._v(" \n      Move and resize your image.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', {
    staticClass: "pr-2"
  }, [_vm._v("Step 3")]), _vm._v(" \n      Click the MINT button.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', {
    staticClass: "pr-2"
  }, [_vm._v("Step 4")]), _vm._v(" \n      Check back in a minute to see your addition!\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "my-4"
  }, [_vm._v("📽️ See it in action")]), _vm._v(" "), _c('p', [_vm._v("\n      Watch an example of how easy it is to claim your plot on the homepage.\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('demo')
      }
    }
  }, [_vm._v("Watch video")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-success",
      "title": "You're a part of blockchain history!",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('p', [_vm._v("\n      Thank you for being a part of blockchain history 💙\n      "), _c('br'), (_vm.trxHashSuccess) ? _c('a', {
    attrs: {
      "href": 'https://basescan.org/tx/' + _vm.trxHashSuccess,
      "target": "_blank"
    }
  }, [_vm._v("View transaction")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Please allow a few minutes to process your pixels from the blockchain and be added to the "), (!_vm.whiteLabel && !_vm.isZora) ? _c('span', [_vm._v("homepage")]) : _vm._e(), (_vm.whiteLabel || _vm.isZora) ? _c('span', [_vm._v("page")]) : _vm._e(), _vm._v(".\n      "), _c('br'), _c('br'), _vm._v("\n      Make sure to join our community on "), _c('a', {
    attrs: {
      "href": _vm.telegram,
      "target": "_blank"
    }
  }, [_vm._v("Telegram")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": _vm.twitter,
      "target": "_blank"
    }
  }, [_vm._v("Twitter")]), _vm._v(".\n      "), _c('br'), _c('br'), _vm._v(" "), (!_vm.whiteLabel && !_vm.isZora) ? _c('span', [_vm._v("Share the Million Bit Homepage with your friends!\n      "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-outline-dark btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.shareUrl)
    },
    on: {
      "click": function($event) {
        return _vm.doCopyToClipboard(_vm.shareUrl)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-lg btn-primary",
    attrs: {
      "href": _vm.xPostSuccess,
      "target": "_blank"
    }
  }, [_vm._v("Share on X")]), _c('br')]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-invite-friends",
      "title": "Invite Friends",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('h1', [_vm._v("Refer your friends!")]), _vm._v(" "), _c('p', [_vm._v("\n      Share the Million Bit Homepage with your friends!\n    ")]), _vm._v(" "), (!_vm.connectAccountAddress) ? _c('span', [_c('b', [_vm._v("Connect your wallet to get your referral link")])]) : _vm._e(), _vm._v(" "), (_vm.connectAccountAddress) ? _c('span', [_c('b', [_vm._v("Share invite link")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-outline-dark btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.shareUrl)
    },
    on: {
      "click": function($event) {
        return _vm.doCopyToClipboard(_vm.shareUrl)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-lg btn-primary",
    attrs: {
      "href": _vm.xPostInvite,
      "target": "_blank"
    }
  }, [_vm._v("Share on X")]), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "fine-uploader-manual-trigger"
    }
  }), _vm._v(" "), (_vm.isMobileOrTouch && _vm.canBuy) ? _c('div', {
    attrs: {
      "id": "mobile-controls"
    }
  }, [_c('div', {
    attrs: {
      "id": "control-down"
    },
    on: {
      "click": _vm.btnPress,
      "touchstart": function($event) {
        return _vm.handleTouchStart($event, 'down')
      },
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchCancel
    }
  }, [_c('svg', {
    staticClass: "bi bi-arrow-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-left"
    },
    on: {
      "click": _vm.btnPress,
      "touchstart": function($event) {
        return _vm.handleTouchStart($event, 'left')
      },
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchCancel
    }
  }, [_c('svg', {
    staticClass: "bi bi-arrow-left",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-right"
    },
    on: {
      "click": _vm.btnPress,
      "touchstart": function($event) {
        return _vm.handleTouchStart($event, 'right')
      },
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchCancel
    }
  }, [_c('svg', {
    staticClass: "bi bi-arrow-right",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-up"
    },
    on: {
      "click": _vm.btnPress,
      "touchstart": function($event) {
        return _vm.handleTouchStart($event, 'up')
      },
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchCancel
    }
  }, [_c('svg', {
    staticClass: "bi bi-arrow-up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-smaller"
    },
    on: {
      "click": function($event) {
        return _vm.resizeSpot('smaller')
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-zoom-out",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-bigger"
    },
    on: {
      "click": function($event) {
        return _vm.resizeSpot('bigger')
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-zoom-in",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isGame),
      expression: "!isGame"
    }],
    staticClass: "bg-white mbh-footer"
  }, [_c('b-navbar', {
    attrs: {
      "variant": "white"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "honk-text"
  }, [_vm._v("MBH")])]), _vm._v(" "), _c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "href": _vm.email,
      "target": "_blank",
      "variant": "link"
    }
  }, [_c('svg', {
    staticClass: "bi bi-envelope",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"
    }
  })])]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": _vm.telegram,
      "target": "_blank",
      "variant": "link"
    }
  }, [_c('svg', {
    staticClass: "bi bi-telegram",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"
    }
  })])]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": _vm.twitter,
      "target": "_blank",
      "variant": "link"
    }
  }, [_c('svg', {
    staticClass: "bi bi-twitter-x",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
    }
  })])]), _vm._v(" "), (false) ? _c('b-nav-item', {
    staticClass: "send-feedback",
    attrs: {
      "variant": "link",
      "href": "https://www.complainonchain.xyz/millionbithomepage",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/keren.webp"
    }
  }), _vm._v(" Feedback")]) : _vm._e(), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showInviteFriends()
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-megaphone-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25 25 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009l.496.008a64 64 0 0 1 1.51.048m1.39 1.081q.428.032.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a66 66 0 0 1 1.692.064q.491.026.966.06"
    }
  })]), _vm._v("\n        Invite friends\n      ")])], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-item', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/agents')
      }
    }
  }, [_vm._v("Agents")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/terms')
      }
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/privacy')
      }
    }
  }, [_vm._v("Privacy")])], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": "",
      "variant": "link",
      "id": "copyright"
    }
  }, [_vm._v("© 2025. All rights reserved. Not responsible for the content of external sites or images featured which are © of their respective owners.")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toast"
    }
  }), _vm._v(" "), (!_vm.watchedDemo && !_vm.whiteLabel && !_vm.isZora) ? _c('div', {
    attrs: {
      "id": "pfp-vid-container"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showDemoVideo.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "pfp-vid"
    }
  }, [(_vm.pfpVidSrc) ? _c('video', {
    attrs: {
      "src": _vm.pfpVidSrc,
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": ""
    },
    domProps: {
      "muted": true
    }
  }) : _vm._e()])]) : _vm._e()], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confetti-wrapper"
  }, [_c('div', {
    staticClass: "js-container c-container"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = iaho
// module chunks = 6